import React from 'react';

/**
 * PlannedModules: Explicitly catalogs capabilities not yet developed in the codebase.
 * Strictly guarantees ZERO fake data or deceptive metrics.
 */
export const PlannedModules = () => {
  const roadmap = [
    {
      title: 'Analyzer & Bi-Directional Instrument Interfacing',
      code: 'ASTM / HL7 INTERFACE',
      description: 'Automated direct query and result capture from automated hematology and biochemistry analyzers.',
      status: 'MODULE NOT READY',
      target: 'Q3 Architectural Roadmap'
    },
    {
      title: 'Reagent & Consumable Inventory Intelligence',
      code: 'INVENTORY & LOT TRACKING',
      description: 'Stock on hand, expiry warnings, minimum reorder alerts, and consumption per test batch.',
      status: 'MODULE NOT READY',
      target: 'Q3 Architectural Roadmap'
    },
    {
      title: 'Automated Multi-Channel Report Delivery Gateway',
      code: 'SMS / WHATSAPP / EMAIL',
      description: 'Direct PDF report dispatch via Twilio / WhatsApp Business API / SMTP gateway upon doctor signature.',
      status: 'NOT CONFIGURED',
      target: 'Gateway Credentials Pending'
    },
    {
      title: 'Predictive Turnaround Time (TAT) & AI Escalation',
      code: 'PREDICTIVE WORKLOAD AI',
      description: 'Machine-learning models identifying potential SLA breaches before specimen incubation finishes.',
      status: 'MODULE NOT READY',
      target: 'Future Release'
    },
    {
      title: 'Enterprise Multi-Centre Financial Benchmarking',
      code: 'ADVANCED BI & AUDIT',
      description: 'Center-wise EBITDA, margin analysis by test package, and doctor referral commission reconciliation.',
      status: 'AVAILABLE-BUT-NOT-EXPOSED',
      target: 'Pending Dedicated BI Aggregator'
    }
  ];

  return (
    <div className="lis-planned-section">
      <div className="lis-planned-header">
        <div>
          <h3 className="lis-planned-title">Enterprise Architecture Roadmap & System Capabilities</h3>
          <p className="lis-planned-sub">
            Genuinely unconfigured or upcoming modules are transparently declared below. No fabricated demo statistics.
          </p>
        </div>
        <span className="lis-planned-badge">ENTERPRISE ROADMAP</span>
      </div>

      <div className="lis-planned-grid">
        {roadmap.map((item, idx) => (
          <div key={idx} className="lis-planned-card">
            <div className="lis-planned-card-header">
              <span className="lis-planned-code">{item.code}</span>
              <span className={`lis-status-badge ${item.status === 'NOT CONFIGURED' ? 'badge-not-configured' : 'badge-not-ready'}`}>
                {item.status}
              </span>
            </div>
            <h4 className="lis-planned-card-title">{item.title}</h4>
            <p className="lis-planned-card-desc">{item.description}</p>
            <div className="lis-planned-card-footer">
              <span className="lis-planned-target">Status: {item.target}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlannedModules;
